export enum PaymentStatus {
  UNPAID = 'Unpaid',
  PAID = 'Paid',
  PARTIAL = 'Partial'
}
